import fromIcon from "../../assets/icons/departure-time.svg";
import toIcon from "../../assets/icons/arrival-time.svg";
import fuelStopIcon from "../../assets/icons/fuel-stop-dark.svg";
import calendarIcon from "../../assets/icons/calendar.svg";
import timeIcon from "../../assets/icons/time.svg";
import durationIcon from "../../assets/icons/duration.svg";
import useJourneyLegIcons from "../../hooks/useJourneyLegIcons";
import getClassName from "../../utilities/getClassName";
import ThemedIcon from "../ui/ThemedIcon";
import { formatJourneyLegs } from "../../utilities/journeyLeg";

/**
 * Table layout for QuoteHeader: Date | Time | From | Duration | To | Passengers | Luggage
 * No arrival time column (layout 11)
 */
const QuoteHeaderJourneyLeg = ({ legs, isSimple, showFuelStop, duration, fuelStop, collapseAfterIndex }) => {
    const { passengerIcon, luggageIcon } = useJourneyLegIcons({ isSimple, layout: 11, isQuotePage: true });
    const formattedLegs = formatJourneyLegs(legs, { duration, fuelStop, shortYear: true });

    return (
        <div className="journey-leg journey-leg--11">
            <table className="journey-leg__table">
                <colgroup>
                    <col className="journey-leg__col-date" />
                    <col className="journey-leg__col-time" />
                    <col className="journey-leg__col-from" />
                    {showFuelStop && <col className="journey-leg__col-duration" />}
                    <col className="journey-leg__col-to" />
                    <col className="journey-leg__col-pax" />
                    <col className="journey-leg__col-luggage" />
                </colgroup>
                <thead className="journey-leg__table-header">
                    <tr>
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <ThemedIcon src={calendarIcon} alt="" className="journey-leg__header-icon" />
                                Date
                            </span>
                        </th>
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <ThemedIcon src={timeIcon} alt="" className="journey-leg__header-icon" />
                                Time
                            </span>
                        </th>
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <ThemedIcon src={fromIcon} alt="" className="journey-leg__header-icon" />
                                From
                            </span>
                        </th>
                        {showFuelStop && (
                            <th className="journey-leg__table-header-cell">
                                <span className="journey-leg__header-content">
                                    <ThemedIcon src={durationIcon} alt="" className="journey-leg__header-icon" />
                                    Duration
                                </span>
                            </th>
                        )}
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <ThemedIcon src={toIcon} alt="" className="journey-leg__header-icon" />
                                To
                            </span>
                        </th>
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <ThemedIcon src={passengerIcon} alt="Passengers" className="journey-leg__header-icon" />
                            </span>
                        </th>
                        <th className="journey-leg__table-header-cell">
                            <span className="journey-leg__header-content">
                                <ThemedIcon src={luggageIcon} alt="Luggage" className="journey-leg__header-icon" />
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody className="journey-leg__table-body">
                    {formattedLegs.map((leg, index) => (
                        <tr
                            key={index}
                            className={getClassName([
                                "journey-leg__table-row",
                                collapseAfterIndex != null &&
                                    index >= collapseAfterIndex &&
                                    "journey-leg__table-row--collapsed",
                            ])}
                        >
                            <td className="journey-leg__table-cell">{leg.formattedDepartureDate}</td>
                            <td className="journey-leg__table-cell">
                                {leg.departureTime} {leg.departureTime && leg.departureTimeZone}
                            </td>
                            <td className="journey-leg__table-cell journey-leg__table-cell--location">
                                <div className="journey-leg__long-form-location">{leg.fromLong}</div>
                                {leg.fromShort && (
                                    <div className="journey-leg__short-form-location">
                                        <span className="journey-leg__code-brackets">(</span>
                                        {leg.fromShort}
                                        <span className="journey-leg__code-brackets">)</span>
                                    </div>
                                )}
                            </td>
                            {showFuelStop && (
                                <td className="journey-leg__table-cell journey-leg__table-cell--duration">
                                    {leg.fuelStop > 0 && (
                                        <ThemedIcon className="journey-leg__fuel-stop-icon" src={fuelStopIcon} />
                                    )}
                                    {leg.duration || "-"}
                                    {leg.fuelStop > 0 && (
                                        <>
                                            <br />
                                            <span className="journey-leg__fuel-stop-text">
                                                {leg.fuelStop === 1 ? "Fuel stop" : `${leg.fuelStop} Fuel stops`}
                                            </span>
                                        </>
                                    )}
                                </td>
                            )}
                            <td className="journey-leg__table-cell journey-leg__table-cell--location">
                                <div className="journey-leg__long-form-location">{leg.toLong}</div>
                                {leg.toShort && (
                                    <div className="journey-leg__short-form-location">
                                        <span className="journey-leg__code-brackets">(</span>
                                        {leg.toShort}
                                        <span className="journey-leg__code-brackets">)</span>
                                    </div>
                                )}
                            </td>
                            <td className="journey-leg__table-cell journey-leg__table-cell--center">
                                <span className="journey-leg__mobile-icon-wrapper">
                                    <ThemedIcon src={passengerIcon} alt="" className="journey-leg__mobile-icon" />
                                    {leg.passengers}
                                </span>
                            </td>
                            <td className="journey-leg__table-cell journey-leg__table-cell--center">
                                <span className="journey-leg__mobile-icon-wrapper">
                                    <ThemedIcon src={luggageIcon} alt="" className="journey-leg__mobile-icon" />
                                    {leg.luggage}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default QuoteHeaderJourneyLeg;
